<div class="container-fluid loader-container">
    <header class="d-flex space-between page-header">
        <h2>
            Producten
        </h2>
        <div class="actions">
            <button (click)="openModal({})" class="btn btn-primary">
                Toevoegen
            </button>
        </div>
    </header>

    <app-table-guru [apiEndpoint]="'/office/products'" [columnMapping]="[
            { key: 'name', label: 'Naam' },
            { key: 'courses', label: 'Methodes', type: 'multi' },
            { key: 'status', label: 'Status' },
            { key: 'price', label: 'Prijs', type: 'monetary' },
            { key: 'ean', label: 'EAN' }
          ]" [itemsPerPage]="10" [viewURL]="'/product/details/'" [openModalComponent]="editFormReference"
        [reload]="reloadItems">
    </app-table-guru>
</div>